import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Modal, Button } from 'react-bootstrap';
import Swal from "sweetalert2";
 // FUNCIONES
import { partesYMDEnZona, ymdEnZona, weekday1a7EnZona, hmEnZona } from "../../funcionesDatos/fechas";
// componentes
import ZonaCargando from '../../paginas/alertas/zonaCargando';

function ModalCambiarHorario({reserva, quienEs, usuario, servicio, ahoraServidor }) {

    const [cargando, setCargando]      = useState(false);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [ocupadas, setOcupadas]       = useState([]);
    const [zonaHoraria, setZonaHoraria] = useState("America/Bogota"); // inicializamos con bogota

    const [fechaSeleccionada, setFechaSeleccionada] = useState(null);
    const [horaSeleccionada, setHoraSeleccionada] = useState("");
    const [franjaSeleccionada, setFranjaSeleccionada] = useState("NA");

    const paqueteSeleccionado = useMemo(() => {
        const paquetesArr = servicio?.paquetes || [];
        const tipo = reserva?.tipoPaquete;

        if (tipo) {
            const encontrado = paquetesArr.find(p => (p?.tipo || '').toString() === tipo);
            if (encontrado) return encontrado;
        }

        return paquetesArr[0] || null;
    }, [servicio, reserva?.tipoPaquete]);

    const modoAgenda    = reserva?.modoAgenda || paqueteSeleccionado?.modoAgenda || 'flexible';
    const unidadEntrega = reserva?.unidadEntrega || paqueteSeleccionado?.unidadEntrega || 'Horas';
    const citasDia      = Number(reserva?.citasDia || paqueteSeleccionado?.citasDia || 1);
    const tipoPaquete   = reserva?.tipoPaquete || null;
    const duracionCitaMin = Number(reserva?.duracionCitaMin || paqueteSeleccionado?.duracionCitaMin || 0) || 60;

    const franjasDia = Array.isArray(paqueteSeleccionado?.franjasDia)
        ? paqueteSeleccionado.franjasDia
        : ["manana", "tarde", "noche"];

    const rangoFlexible = useMemo(
        () => rangoHoraPorFranja(franjaSeleccionada),
        [franjaSeleccionada]
    );

    const horasFlexibles = useMemo(
        () => generarHorasFranja(rangoFlexible.min, rangoFlexible.max, 15),
        [rangoFlexible]
    );



    const contraparte = quienEs === "Vendedor" ? "comprador" : "vendedor";
    const intentosUsados = Number(reserva?.intentosCambioHorario || 0);
    const intentosRestantes = Math.max(0, 2 - intentosUsados);

    const ahoraParaCalendario = useMemo(() => {
        const fecha = ahoraServidor ? new Date(ahoraServidor) : new Date();
        return Number.isNaN(fecha.getTime()) ? new Date() : fecha;
    }, [ahoraServidor]);


    //REPETIMOS PROCESO DE RESERVA
    // USEEFFECT PRINCIPAL
    useEffect(() => {
        (async () => {
        try {
        setCargando(true);
        
        // buscar horarios ocupados
        const resOcupados = await axios.post("/obtener-horarios-ocupados", { params: { reserva, servicio, usuario, quienEs } });

        setCargando(false);
        setOcupadas(resOcupados.data.ocupadas);
        setZonaHoraria(servicio?.zonaHoraria || reserva?.zonaHoraria || "America/Bogota");
        } 
        catch (err) {
            console.log("Error en reserva:", err);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Ocurrió un error cargando la reserva.",
                customClass: {
                    popup: 'mi-modal',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                }
            });
        }
        finally { setCargando(false); }
        })();
    }, []);


    // --- Helpers calendario ---
    const diasNombres = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];

    function ymd(d) { return ymdEnZona(d, zonaHoraria); }

    function crearMes(year, monthIndex) {
        // monthIndex: 0-11
        const first = new Date(Date.UTC(year, monthIndex, 1, 12, 0, 0));
        const last = new Date(Date.UTC(year, monthIndex + 1, 0, 12, 0, 0));

        const startDay = weekday1a7EnZona(first, zonaHoraria) - 1;
        const totalDays = last.getUTCDate();

        const cells = [];
        for (let i = 0; i < startDay; i++) cells.push(null);
        for (let day = 1; day <= totalDays; day++) {
            cells.push(new Date(Date.UTC(year, monthIndex, day, 12, 0, 0)));
        }
        while (cells.length % 7 !== 0) cells.push(null);

        const weeks = [];
        for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));

        return { first, weeks };
    }

    function nombreMes(dateObj) {
        return new Intl.DateTimeFormat('es-CO', {
            timeZone: zonaHoraria,
            month: 'long',
            year: 'numeric'
        }).format(dateObj);
    }

    function esDiaDisponible(dateObj) {
        if (!dateObj) return false;

        const ahora = ahoraParaCalendario; // Fecha centralizada desde backend para pruebas.
        const diaEvaluadoYMD = ymdEnZona(dateObj, zonaHoraria);
        const hoyYMD = ymdEnZona(ahora, zonaHoraria);

        if (diaEvaluadoYMD < hoyYMD) return false;

        // Día bloqueado completo por el vendedor (/vendedor/agenda).
        return !reservasDelDia(dateObj).some((r) => r?.esBloqueo && r?.diaCompleto);
    }


    function ymdFechaGuardada(fecha) {
        if (!fecha) return "";

        const textoFecha = fecha instanceof Date ? fecha.toISOString() : String(fecha);
        const ymdGuardado = textoFecha.slice(0, 10);

        return /^\d{4}-\d{2}-\d{2}$/.test(ymdGuardado) ? ymdGuardado : "";
    }

    function rangoYmdReserva(reservaItem) {
        if (!reservaItem) return null;

        if (reservaItem?.modoAgenda === 'flexible' && reservaItem?.fecha) {
            const diaFlexible = ymdFechaGuardada(reservaItem.fecha);

            if (diaFlexible) {
                return {
                    inicio: diaFlexible,
                    fin: diaFlexible,
                };
            }
        }

        const inicioHoras = reservaItem?.inicio ? new Date(reservaItem.inicio) : null;
        const finHoras = reservaItem?.fin ? new Date(reservaItem.fin) : null;

        if (
            inicioHoras &&
            !Number.isNaN(inicioHoras.getTime()) &&
            finHoras &&
            !Number.isNaN(finHoras.getTime())
        ) {
            return {
                inicio: ymdEnZona(inicioHoras, zonaHoraria),
                fin: ymdEnZona(finHoras, zonaHoraria),
            };
        }

        if (inicioHoras && !Number.isNaN(inicioHoras.getTime())) {
            const mismoDia = ymdEnZona(inicioHoras, zonaHoraria);
            return {
                inicio: mismoDia,
                fin: mismoDia,
            };
        }

        if (!reservaItem?.fecha) return null;

        const inicioYmd = ymdFechaGuardada(reservaItem.fecha);
        const finYmd = reservaItem?.fechaFin ? ymdFechaGuardada(reservaItem.fechaFin) : inicioYmd;

        if (!inicioYmd) return null;

        return {
            inicio: inicioYmd,
            fin: finYmd || inicioYmd,
        };
    }

    function reservaOcupaDia(reservaItem, dateObj) {
        if (!dateObj) return false;
        const rango = rangoYmdReserva(reservaItem);
        if (!rango) return false;

        const dia = ymd(dateObj);
        return dia >= rango.inicio && dia <= rango.fin;
    }

    function reservasDelDia(dateObj) {
        const lista = Array.isArray(ocupadas) ? ocupadas : [];
        // La reserva que se está cambiando no se ocupa a sí misma (el backend ya la excluye; esto cubre
        // respuestas de un backend anterior al cambio).
        const idActual = String(reserva?._id || reserva?.idReserva || "");
        return lista.filter((r) => String(r?._id || "") !== idActual && reservaOcupaDia(r, dateObj));
    }

    function horaReservaOcupada(reservaItem) {
        if (!reservaItem) return '';

        if (reservaItem?.horaConfirmada && reservaItem.horaConfirmada !== 'NA') {
            return String(reservaItem.horaConfirmada);
        }

        if (reservaItem?.horaSolicitada && reservaItem.horaSolicitada !== 'NA') {
            return String(reservaItem.horaSolicitada);
        }

        if (reservaItem?.horarioExacto && reservaItem.horarioExacto !== 'NA') {
            return String(reservaItem.horarioExacto);
        }

        if (reservaItem?.inicio) {
            const inicio = new Date(reservaItem.inicio);
            if (!Number.isNaN(inicio.getTime())) {
                return hmEnZona(inicio, zonaHoraria);
            }
        }

        return '';
    }

    function rangoHoraReservaOcupada(reservaItem) {
        if (!reservaItem) return null;

        const inicioDate = reservaItem?.inicio ? new Date(reservaItem.inicio) : null;
        const finDate = reservaItem?.fin ? new Date(reservaItem.fin) : null;

        if (inicioDate && finDate && !Number.isNaN(inicioDate.getTime()) && !Number.isNaN(finDate.getTime())) {
            return {
                inicio: hmEnZona(inicioDate, zonaHoraria),
                fin: hmEnZona(finDate, zonaHoraria),
            };
        }

        const hora = horaReservaOcupada(reservaItem);
        if (!hora) return null;

        return { inicio: hora, fin: hora };
    }

    function horaOcupadaEnDia(dateObj, hora) {
        if (!dateObj || !hora) return false;

        const toMin = (hhmm) => {
            if (!hhmm || !String(hhmm).includes(':')) return null;
            const [hh, mm] = String(hhmm).split(':');
            return (Number(hh) * 60) + Number(mm);
        };

        const horaMin = toMin(hora);
        if (horaMin === null) return false;

        return reservasDelDia(dateObj).some((r) => {
            const rango = rangoHoraReservaOcupada(r);
            if (!rango?.inicio) return false;

            const inicioMin = toMin(rango.inicio);
            let finMin = toMin(rango.fin || rango.inicio);
            if (inicioMin === null || finMin === null) return false;

            // Sin fin conocido (solo hora): asumimos que dura lo mismo que la cita de esta reserva.
            if (finMin === inicioMin) finMin = inicioMin + duracionCitaMin;
            // Cruza la medianoche: en este día ocupa hasta el final.
            if (finMin < inicioMin) finMin = 24 * 60;

            // La cita COMPLETA [hora, hora + duración) no puede cruzarse con lo ocupado (reservas,
            // carritos vigentes y bloqueos del vendedor), no solo su hora de inicio.
            return horaMin < finMin && (horaMin + duracionCitaMin) > inicioMin;
        });
    }

    function seleccionarFecha(d) {
        if (!d) return;
        if (!esDiaDisponible(d)) return;

        setFechaSeleccionada(d);
        setFranjaSeleccionada("NA");
        setHoraSeleccionada("");
    }

    function rangoHoraPorFranja(franja) {
        if (franja === "manana") return { min: "06:00", max: "12:00" };
        if (franja === "tarde")  return { min: "12:00", max: "18:00" };
        if (franja === "noche")  return { min: "18:00", max: "22:00" };
        return { min: "06:00", max: "22:00" };
    }

    function generarHorasFranja(min, max, pasoMin = 15) {
        if (!min || !max) return [];

        const toMin = (hhmm) => {
            const [hh, mm] = String(hhmm).split(":");
            return (Number(hh) * 60) + Number(mm);
        };

        const toHHMM = (mins) => {
            const hh = Math.floor(mins / 60);
            const mm = mins % 60;
            return `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
        };

        const inicio = toMin(min);
        const fin = toMin(max);
        const horas = [];

        for (let actual = inicio; actual <= fin; actual += pasoMin) {
            horas.push(toHHMM(actual));
        }

        return horas;
    }

    function etiquetaFranja(f) {
        if (f === "manana") return "Mañana";
        if (f === "tarde") return "Tarde";
        if (f === "noche") return "Noche";
        return "—";
    }





    async function cambiarHorario() {
        if (!reserva?._id) {
            return Swal.fire({
                icon: "error",
                title: "Reserva no encontrada",
                text: "No pudimos identificar la reserva para cambiar el horario.",
                customClass: {
                    popup: 'mi-modal',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                }
            });
        }

        if (!fechaSeleccionada) {
            return Swal.fire({
                icon: "error",
                title: "Falta la fecha",
                text: "Selecciona una fecha para continuar.",
                customClass: {
                    popup: 'mi-modal',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                }
            });
        }

        if (franjaSeleccionada === "NA") {
            return Swal.fire({
                icon: "error",
                title: "Falta la franja",
                text: "Selecciona una franja para continuar.",
                customClass: {
                    popup: 'mi-modal',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                }
            });
        }

        if (!horaSeleccionada) {
            return Swal.fire({
                icon: "error",
                title: "Falta la hora",
                text: "Selecciona una hora sugerida para continuar.",
                customClass: {
                    popup: 'mi-modal',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                }
            });
        }

        try {
            setCargando(true);

            const nuevoHorario = {
                fecha: ymd(fechaSeleccionada),
                franja: franjaSeleccionada,
                horaSolicitada: horaSeleccionada,
                horaConfirmada: "NA",
                horarioExacto: "NA",
                modoAgenda,
                unidadEntrega,
            };

            await axios.post("/cambiar-horario", {
                params: {
                    idReserva: reserva._id,
                    reserva,
                    servicio,
                    usuario,
                    quienEs,
                    nuevoHorario,
                }
            });
            setCargando(false);

            Swal.fire({
                icon: "success",
                title: "Horario enviado",
                text: `El nuevo horario fue enviado al ${contraparte} para confirmación.`,
                timer: 1600,
                showConfirmButton: false,
                customClass: {
                    popup: 'mi-modal',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                }
            });
            
            setShow(false);
            return window.location.reload();
        }
        catch (err) {
            console.log("Error cambiando horario:", err);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: err?.response?.data?.mensaje || "No pudimos enviar el cambio de horario. Intenta nuevamente.",
                customClass: {
                    popup: 'mi-modal',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                }
            });
        }
        finally {
            setCargando(false);
        }
    }
    


    //console.log("ocupadas: ", ocupadas);




    return(
    <div>
        <Button className="w-100 mt-3 rounded-pill fw-semibold" variant="secondary" onClick={handleShow}>
            <i className="bi bi-calendar2-week-fill me-2"></i>
            Cambiar Horario
        </Button>

        <Modal show={show} onHide={handleClose} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title> Aquí puedes cambiar el horario </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div>
                    {cargando ? <ZonaCargando /> :
                    <>
                        <p className="mb-2 text-muted">
                            Puedes escoger un nuevo horario.
                        </p>

                        <div
                            className="rounded-3 p-3 mb-3"
                            style={{ background: 'rgba(var(--naranja-cta-rgb), 0.10)', border: '1px solid rgba(var(--naranja-cta-rgb), 0.22)', color: 'var(--marron-oscuro)', fontSize: 13, lineHeight: 1.5, }}
                        >
                            <div className="d-flex align-items-start gap-2">
                                <i className="bi bi-info-circle-fill mt-1"></i>
                                <div>
                                    <div className="fw-semibold mb-1">Ten en cuenta antes de cambiar el horario</div>
                                    <div>
                                        Este nuevo horario deberá ser confirmado por el {contraparte}. Solo tendrán <strong>2 oportunidades</strong> para modificarlo. Si no hay una nueva respuesta, quedará asignado automáticamente el último horario seleccionado. Tienen <strong>1 hora desde la compra</strong> para completar este proceso. Recomendamos usar la zona de chat para coordinar un horario aprobado por ambos.
                                    </div>

                                    <div className="mt-2 fw-semibold">
                                        {intentosRestantes === 1
                                            ? "Te queda 1 intento para modificar el horario."
                                            : intentosRestantes > 1
                                                ? `Te quedan ${intentosRestantes} intentos para modificar el horario.`
                                                : "Ya no quedan intentos para modificar el horario."}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="text-body-secondary mb-3" style={{ fontSize: 12 }}>
                            Horarios en zona del servicio: <span className="fw-semibold">{zonaHoraria}</span>
                        </div>

                        {(() => {
                            const { y: yNow, m: mNow } = partesYMDEnZona(ahoraParaCalendario, zonaHoraria);
                            const m1 = crearMes(yNow, mNow - 1);

                            const nextMonthIndex = (mNow - 1) + 1;
                            const y2 = nextMonthIndex > 11 ? (yNow + 1) : yNow;
                            const m2Index = nextMonthIndex % 12;
                            const m2 = crearMes(y2, m2Index);

                            const renderMes = (mes) => (
                                <div className="mb-4">
                                    <div className="text-capitalize fw-semibold mb-2">
                                        {nombreMes(mes.first)}
                                    </div>

                                    <div className="d-grid" style={{ gridTemplateColumns: 'repeat(7, 1fr)', gap: 6 }}>
                                        {diasNombres.map((d) => (
                                            <div key={`h-${d}`} className="text-center text-body-secondary" style={{ fontSize: 12 }}>
                                                {d}
                                            </div>
                                        ))}

                                        {mes.weeks.flat().map((cell, idx) => {
                                            if (!cell) return <div key={`e-${idx}`} />;

                                            const disponible = esDiaDisponible(cell);

                                            return (
                                                <button
                                                    key={`d-${idx}`}
                                                    type="button"
                                                    className={`btn btn-sm ${fechaSeleccionada && ymd(cell) === ymd(fechaSeleccionada) ? 'btn-primary' : (disponible ? 'btn-outline-primary' : 'btn-light')}`}
                                                    style={{ padding: '3px 0', border: disponible ? undefined : '1px solid var(--color-disabled-border)', color: disponible ? undefined : 'var(--color-disabled-text)', background: disponible ? undefined : 'var(--color-disabled-bg)', cursor: disponible ? 'pointer' : 'not-allowed', }}
                                                    disabled={!disponible}
                                                    onClick={() => seleccionarFecha(cell)}
                                                >
                                                    {partesYMDEnZona(cell, zonaHoraria).d}
                                                </button>
                                            );
                                        })}
                                    </div>
                                </div>
                            );

                            return (
                                <>
                                    {renderMes(m1)}
                                    {renderMes(m2)}
                                </>
                            );
                        })()}

                        <div className="mt-2">
                            <div className="fw-semibold mb-1">Hora</div>

                            {unidadEntrega === 'Horas' && modoAgenda === 'flexible' ? (
                                <>
                                    <div className="text-body-secondary" style={{ fontSize: 13 }}>
                                        Selecciona una franja y una hora sugerida. El {contraparte} deberá confirmar este nuevo horario.
                                    </div>

                                    <div className="d-flex flex-wrap gap-2 mt-2">
                                        {franjasDia.map((f) => (
                                            <button
                                                key={`fr-${f}`}
                                                type="button"
                                                className={`btn btn-sm ${franjaSeleccionada === f ? "btn-primary" : "btn-outline-secondary"}`}
                                                onClick={() => {
                                                    setFranjaSeleccionada(f);
                                                    setHoraSeleccionada("");
                                                }}
                                            >
                                                {etiquetaFranja(f)}
                                            </button>
                                        ))}
                                    </div>

                                    <div className="mt-2">
                                        <div className="d-flex flex-wrap gap-2 mt-3">
                                            {franjaSeleccionada === "NA" ?
                                                <div className="text-body-secondary" style={{ fontSize: 12 }}>
                                                    Primero selecciona una franja.
                                                </div>
                                            : horasFlexibles.length > 0 ?
                                                horasFlexibles.map((h) => {
                                                    const ocupada = fechaSeleccionada ? horaOcupadaEnDia(fechaSeleccionada, h) : false;
                                                    const diaLleno = fechaSeleccionada ? reservasDelDia(fechaSeleccionada).filter(r => !r.esBloqueo && (r.tipoPaquete === tipoPaquete || !r.tipoPaquete)).length >= citasDia : false;

                                                    return (
                                                        <button
                                                            key={`hf-${franjaSeleccionada}-${h}`}
                                                            type="button"
                                                            className={`btn btn-sm ${horaSeleccionada === h ? 'btn-primary' : (ocupada || diaLleno ? 'btn-light' : 'btn-outline-secondary')}`}
                                                            onClick={() => {
                                                                if (ocupada || diaLleno) return;
                                                                setHoraSeleccionada(h);
                                                            }}
                                                            disabled={!fechaSeleccionada || ocupada || diaLleno}
                                                            title={
                                                                diaLleno
                                                                    ? 'Este día ya alcanzó el máximo de citas'
                                                                    : ocupada
                                                                        ? 'Esta hora ya está ocupada'
                                                                        : (!fechaSeleccionada ? 'Primero selecciona una fecha' : '')
                                                            }
                                                            style={{
                                                                fontSize: 12,
                                                                padding: '3px 8px',
                                                                ...((ocupada || diaLleno) ? {
                                                                    opacity: 0.65,
                                                                    cursor: 'not-allowed',
                                                                    color: 'var(--color-text-secondary)',
                                                                    borderColor: 'var(--color-border)',
                                                                    background: 'var(--color-bg-page)'
                                                                } : {}),
                                                            }}
                                                        >
                                                            {h}{diaLleno ? ' · día lleno' : (ocupada ? ' · ocupada' : '')}
                                                        </button>
                                                    );
                                                })
                                            : <div className="text-body-secondary" style={{ fontSize: 12 }}>
                                                No hay horas configuradas para esta franja.
                                            </div>
                                            }
                                        </div>

                                        <div className="text-body-secondary" style={{ fontSize: 12, marginTop: 6 }}>
                                            {franjaSeleccionada === "NA"
                                                ? "Primero selecciona una franja."
                                                : `Rango sugerido: ${rangoFlexible.min} - ${rangoFlexible.max}.`}
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div className="text-body-secondary" style={{ fontSize: 13 }}>
                                    Este cambio de horario por ahora solo aplica para reservas con agenda flexible.
                                </div>
                            )}
                        </div>

                        <div className="mt-3 pt-3 border-top">
                            <h6 className="mb-1">Resumen</h6>

                            <div className="text-body-secondary" style={{ fontSize: 13 }}>
                                Fecha: {fechaSeleccionada ? ymd(fechaSeleccionada) : '—'}
                                {unidadEntrega === 'Horas' && modoAgenda === 'flexible'
                                    ? ` · Franja: ${franjaSeleccionada !== "NA" ? etiquetaFranja(franjaSeleccionada) : "—"} · Hora propuesta: ${horaSeleccionada || '—'}`
                                    : ''}
                            </div>
                        </div>

                        <Button
                            type="button"
                            variant="dark"
                            className="w-100 mt-3 rounded-pill fw-semibold"
                            disabled={
                                cargando ||
                                !fechaSeleccionada ||
                                franjaSeleccionada === "NA" ||
                                !horaSeleccionada
                            }
                            onClick={cambiarHorario}
                        >
                            <i className="bi bi-calendar-check me-2"></i>
                            cambiarHorario
                        </Button>
                    </>
                    }
                </div>
            </Modal.Body>
        </Modal>
    </div>
    )
}



export default ModalCambiarHorario;